import type {MouseEvent} from "react";
import classNames from "classnames";

import {SearchComboboxCloseIcon} from "../icons/SearchComboboxCloseIcon";
import type {ISearchComboboxOptionProps} from "../types/ISearchComboboxOptionProps";
import {SearchComboboxKbd} from "./SearchComboboxKbd";

import * as styles from "./SearchComboboxOption.module.css";

const preventFocusLoss = (event: MouseEvent<HTMLButtonElement>) => event.preventDefault();

/**
 * Suggestion row (62px): icon tile, one-line title and subtitle, metrics, and on the active row the ↵ key
 * cap. The optional × removes the row (recent searches) without selecting it; it is out of the tab order because focus
 * stays in the input and the keyboard path is Delete / Shift+Delete. A disabled row (no data behind it) is muted and
 * inert - the hook never makes it active and ignores its clicks.
 */
export const SearchComboboxOption = (props: ISearchComboboxOptionProps) => {
    const {
        icon,
        title,
        subtitle,
        isSubtitleWrapped,
        meta,
        showKbd,
        onRemove,
        removeLabel,
        removeDataTestId,
        isActive,
        isDisabled,
        className,
        dataTestId,
        ...optionProps
    } = props;
    const isActiveResolved = isActive ?? optionProps["aria-selected"] === true;
    const isDisabledResolved = isDisabled ?? optionProps["aria-disabled"] === true;

    return (
        <div
            role="option"
            aria-selected={false}
            {...optionProps}
            className={classNames(styles.option, isActiveResolved && styles.optionActive, isDisabledResolved && styles.optionDisabled, className)}
            data-testid={dataTestId}
        >
            {icon ? <span className={styles.tile}>{icon}</span> : null}

            <span className={styles.text}>
                <span className={styles.title}>{title}</span>
                {subtitle ? <span className={classNames(styles.subtitle, isSubtitleWrapped && styles.subtitleWrapped)}>{subtitle}</span> : null}
            </span>

            {meta ? <span className={styles.meta}>{meta}</span> : null}

            {showKbd && isActiveResolved && !isDisabledResolved ? <SearchComboboxKbd className={styles.kbd} /> : null}

            {onRemove && !isDisabledResolved ? (
                <button
                    type="button"
                    tabIndex={-1}
                    className={styles.remove}
                    aria-label={removeLabel}
                    onMouseDown={preventFocusLoss}
                    onClick={(event) => {
                        event.stopPropagation();
                        onRemove();
                    }}
                    data-testid={removeDataTestId}
                >
                    <SearchComboboxCloseIcon size={16} />
                </button>
            ) : null}
        </div>
    );
};
import type {MouseEvent} from "react";
import classNames from "classnames";

import {SearchComboboxCloseIcon} from "../icons/SearchComboboxCloseIcon";
import type {ISearchComboboxOptionProps} from "../types/ISearchComboboxOptionProps";
import {SearchComboboxKbd} from "./SearchComboboxKbd";

import * as styles from "./SearchComboboxOption.module.css";

const preventFocusLoss = (event: MouseEvent<HTMLButtonElement>) => event.preventDefault();

/**
 * Suggestion row (62px): icon tile, one-line title and subtitle, metrics, and on the active row the ↵ key
 * cap. The optional × removes the row (recent searches) without selecting it; it is out of the tab order because focus
 * stays in the input and the keyboard path is Delete / Shift+Delete. A disabled row (no data behind it) is muted and
 * inert - the hook never makes it active and ignores its clicks.
 */
export const SearchComboboxOption = (props: ISearchComboboxOptionProps) => {
    const {
        icon,
        title,
        subtitle,
        isSubtitleWrapped,
        meta,
        showKbd,
        onRemove,
        removeLabel,
        removeDataTestId,
        isActive,
        isDisabled,
        className,
        dataTestId,
        ...optionProps
    } = props;
    const isActiveResolved = isActive ?? optionProps["aria-selected"] === true;
    const isDisabledResolved = isDisabled ?? optionProps["aria-disabled"] === true;

    return (
        <div
            role="option"
            aria-selected={false}
            {...optionProps}
            className={classNames(styles.option, isActiveResolved && styles.optionActive, isDisabledResolved && styles.optionDisabled, className)}
            data-testid={dataTestId}
        >
            {icon ? <span className={styles.tile}>{icon}</span> : null}

            <span className={styles.text}>
                <span className={styles.title}>{title}</span>
                {subtitle ? <span className={classNames(styles.subtitle, isSubtitleWrapped && styles.subtitleWrapped)}>{subtitle}</span> : null}
            </span>

            {meta ? <span className={styles.meta}>{meta}</span> : null}

            {showKbd && isActiveResolved && !isDisabledResolved ? <SearchComboboxKbd className={styles.kbd} /> : null}

            {onRemove && !isDisabledResolved ? (
                <button
                    type="button"
                    tabIndex={-1}
                    className={styles.remove}
                    aria-label={removeLabel}
                    onMouseDown={preventFocusLoss}
                    onClick={(event) => {
                        event.stopPropagation();
                        onRemove();
                    }}
                    data-testid={removeDataTestId}
                >
                    <SearchComboboxCloseIcon size={16} />
                </button>
            ) : null}
        </div>
    );
};
